module.exports = __webpack_public_path__ + "img/uranus.6841a819.jpg";